
/* injects from baggage-loader */

'use strict';

export default class AboutController {

	constructor($log, GFAQS, NFAQS, CFAQS) {
		'ngInject';

		this.$log = $log;

		this.gfaqs = GFAQS;
		this.nfaqs = NFAQS;
		this.cfaqs = CFAQS;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/about/about.controller.js